import { List, ListItem, ListItemText, withStyles } from "@material-ui/core";
import React from "react";
import style from "style";
import Item from ".";

const SectionItemTitle = ({ classes, title, subItems, ...other }) => {
  return (
    <List>
      <ListItem className={classes.subNavTitle}>
        <ListItemText primary={title} />
      </ListItem>
      <List disablePadding className={classes.indent2rem}>
        {subItems.map((item) => {
          return <Item {...other} {...item} />;
        })}
      </List>
    </List>
  );
};

export default withStyles(style)(SectionItemTitle);
